import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { LinearProgress, Text, Tooltip } from "@flat-ui";
/** Details of a subscription limit */
export function UsageLimit(t0) {
  const $ = _c(28);
  const {
    current,
    max,
    percentage: t1,
    currentUnit: t2,
    maxUnit: t3,
    decimalPlaces
  } = t0;
  const percentage = t1 === undefined ? 0 : t1;
  const currentUnit = t2 === undefined ? "" : t2;
  const maxUnit = t3 === undefined ? "" : t3;
  let t4;
  if ($[0] !== decimalPlaces || $[1] !== max) {
    t4 = decimalPlaces ? max?.toFixed(decimalPlaces) : max;
    $[0] = decimalPlaces;
    $[1] = max;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const maxToDisplay = t4;
  let t5;
  if ($[3] !== current || $[4] !== decimalPlaces) {
    t5 = decimalPlaces ? current.toFixed(decimalPlaces) : current;
    $[3] = current;
    $[4] = decimalPlaces;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const currentToDisplay = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 3.5
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== currentToDisplay || $[8] !== currentUnit) {
    t7 = <Text variant="heading20">{currentToDisplay} {currentUnit}</Text>;
    $[7] = currentToDisplay;
    $[8] = currentUnit;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== max || $[11] !== maxToDisplay || $[12] !== maxUnit) {
    t8 = max && <Text variant="bodyM">{` / ${maxToDisplay} ${maxUnit}`}</Text>;
    $[10] = max;
    $[11] = maxToDisplay;
    $[12] = maxUnit;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <Box>{t7}{t8}</Box>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== currentToDisplay || $[18] !== currentUnit || $[19] !== decimalPlaces || $[20] !== max || $[21] !== maxToDisplay || $[22] !== maxUnit || $[23] !== percentage) {
    t10 = max && <Tooltip component="div" title={`${currentToDisplay} ${currentUnit} of ${maxToDisplay} ${maxUnit} used (${percentage.toFixed(decimalPlaces)}%)`} placement="top" followCursor={true} sx={{
      flexGrow: 1
    }}><LinearProgress sx={{
        width: "100%"
      }} variant="determinate" value={Math.min(percentage, 100)} /></Tooltip>;
    $[17] = currentToDisplay;
    $[18] = currentUnit;
    $[19] = decimalPlaces;
    $[20] = max;
    $[21] = maxToDisplay;
    $[22] = maxUnit;
    $[23] = percentage;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <Box sx={t6}>{t9}{t10}</Box>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}